import Trix from "trix";
import { ReactElement, forwardRef } from "react";
import { useFormState } from "react-hook-form";
import { ControlInputFieldProps } from "components/Form/typings";
import FormField from "../FormField";
import TrixEditor from "./TrixEditor";
import { RichText } from "./trixrichtext";

type Props = ControlInputFieldProps & {
  onInitialize?: (event: Event, richText: RichText) => void;
  isEditable?: boolean;
  hideToolbar?: boolean;
  alwaysShowToolbar?: boolean;
  includeAttachment?: boolean;
  includePersonalize?: boolean;
  toolbarBgColor?: string;
  editorBgColor?: string;
};

const TrixTextAreaField = forwardRef<Trix, Props>((props, ref) => {
  const {
    name,
    label,
    control,
    helperText,
    errors: errorsFromProps,
    required,
    variant,
    formFieldProps = {},
    ...rest
  } = props;

  const formVariant = variant;

  // Fetch errors from form state to ensure reactivity
  const { errors: formStateErrors } = useFormState({ control });

  // Use formStateErrors for proper reactivity, fallback to props
  const errors = formStateErrors || errorsFromProps || {};

  return (
    <TrixEditor
      name={name}
      control={control}
      trixRef={ref}
      wrapper={(editorFlex: ReactElement, hasValue: boolean) => (
        <FormField
          name={name}
          label={label}
          errors={errors}
          helperText={helperText}
          required={required}
          variant={formVariant}
          labelProps={{ ...(hasValue && { className: "has-value" }) }}
          {...formFieldProps}
        >
          {editorFlex}
        </FormField>
      )}
      {...rest}
    />
  );
});
TrixTextAreaField.displayName = "TrixTextAreaField";

export default TrixTextAreaField;
